import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=cf8b9e8e&scoped=true&"
import script from "./Dynamic.vue?vue&type=script&lang=ts&"
export * from "./Dynamic.vue?vue&type=script&lang=ts&"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=cf8b9e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8b9e8e",
  null
  
)

export default component.exports